var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlien = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 226.4,
    viewBox: "0 0 403 365",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.998%",
    y1: "99.984%",
    x2: "49.998%",
    y2: "-.026%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#908D92",
    offset: "41.08%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#938F93",
    offset: "41.78%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEA598",
    offset: "50.21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3B69D",
    offset: "59.35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2C3A0",
    offset: "69.56%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DACAA1",
    offset: "81.59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDCCA2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.375%",
    y1: "135.533%",
    x2: "50.602%",
    y2: "-41.732%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#908D92",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9694",
    offset: "4.052%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3AA99",
    offset: "15.35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6B99D",
    offset: "28.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3C4A0",
    offset: "43.12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBCAA2",
    offset: "62.27%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDCCA2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.607%",
    y1: ".58%",
    x2: "63.454%",
    y2: "104.099%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#639EF7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#639DF5",
    offset: "45.83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6197EE",
    offset: "62.34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8EE3",
    offset: "74.11%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C82D2",
    offset: "83.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5871BC",
    offset: "91.78%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#535DA1",
    offset: "98.86%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52599C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: ".002%",
    y1: "49.887%",
    x2: "99.896%",
    y2: "49.887%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#639EF7",
    offset: "39.96%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#629DF5",
    offset: "66.36%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F98EE",
    offset: "75.86%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A90E3",
    offset: "82.64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5384D2",
    offset: "88.12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4975BC",
    offset: "92.81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D63A1",
    offset: "96.89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.057%",
    y1: "50.054%",
    x2: "99.988%",
    y2: "50.054%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D63A1",
    offset: "3.106%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4975BC",
    offset: "7.188%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5384D2",
    offset: "11.88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A90E3",
    offset: "17.36%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F98EE",
    offset: "24.14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#629DF5",
    offset: "33.64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#639EF7",
    offset: "60.04%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-3.061%",
    y1: "50.013%",
    x2: "99.921%",
    y2: "50.013%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D63A1",
    offset: "3.106%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4975BC",
    offset: "7.188%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5384D2",
    offset: "11.88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A90E3",
    offset: "17.36%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F98EE",
    offset: "24.14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#629DF5",
    offset: "33.64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#639EF7",
    offset: "60.04%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: ".118%",
    y1: "50.812%",
    x2: "99.777%",
    y2: "50.812%",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#639EF7",
    offset: "39.96%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#629DF5",
    offset: "66.36%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F98EE",
    offset: "75.86%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A90E3",
    offset: "82.64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5384D2",
    offset: "88.12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4975BC",
    offset: "92.81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D63A1",
    offset: "96.89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.6 354.9c-95 0-172.4-77.3-172.4-172.4 0-95.1 77.3-172.4 172.4-172.4 95.1 0 172.4 77.3 172.4 172.4 0 95.1-77.4 172.4-172.4 172.4z",
    fill: "#325187"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M350.3 208.7l-23.7 14h-29.2l-37.8-32.4-157 34.8L90.4 214l-33.6 27.7-37-19-4.1 11.4L36 285.7l75.1 59.2 74.6 15.7 52.2-14.9 52.5-27.1 40.2-42.1 14.3-42.4z",
    transform: "translate(37)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M350.3 239.4l-51.8 6.2-38.6-4.9-120 4.9-51.6 5.5-58.4 3.3 6.1 15.2 25.2 40.5 46.4 30.6 58.3 12.5 40.3 1.5 62.4-16.3 37.5-38z",
    transform: "translate(37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.2 345.7H141.4c-9.8 0-17.8-8-17.8-17.8V212.4c0-34.7 28.1-62.8 62.8-62.8 34.7 0 62.8 28.1 62.8 62.8v133.3z",
    fill: "url(#c)",
    transform: "translate(37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.6 20.2c89.7 0 162.4 72.7 162.4 162.4S309.3 345 219.6 345 57.2 272.3 57.2 182.6 129.9 20.2 219.6 20.2zm0-20c-24.6 0-48.5 4.8-71 14.3-21.7 9.2-41.2 22.3-58 39.1-16.8 16.8-29.9 36.2-39.1 58-9.5 22.5-14.3 46.4-14.3 71s4.8 48.5 14.3 71c9.2 21.7 22.3 41.2 39.1 58 16.7 16.7 36.2 29.9 58 39.1 22.5 9.5 46.4 14.3 71 14.3s48.5-4.8 71-14.3c21.7-9.2 41.2-22.3 58-39.1 16.7-16.7 29.9-36.2 39.1-58 9.5-22.5 14.3-46.4 14.3-71s-4.8-48.5-14.3-71c-9.2-21.7-22.3-41.2-39.1-58-16.8-16.8-36.2-29.9-58-39.1C268.1 5 244.2.2 219.6.2z",
    fill: "#243865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.4 248.8l15.5 2.5c6.6 1.2 12.8 4.5 17.3 9.3 4.5 4.7 7.5 10.9 8.3 17.3.2 1.6.3 3.2.2 4.8v1.5c0 .5 0 1 .1 1.5.2 2 .7 3.9 1.5 5.7 1.6 3.7 4.5 6.9 8.1 9 1.8 1.1 3.8 1.8 5.8 2.2 1 .2 2.1.3 3.2.4l3.9.2 31 1.5v5.4l-31 1.5-3.9.2c-1.5 0-3 0-4.6-.2-3-.4-6-1.2-8.8-2.6-5.6-2.6-10.4-7.1-13.4-12.6-1.5-2.8-2.6-5.8-3.2-8.9-.1-.8-.3-1.6-.3-2.4 0-.4-.1-.8-.1-1.2l-.1-1.1c-.1-1-.2-2-.4-2.9-.8-3.8-2.9-7.2-5.7-9.7-2.8-2.5-6.4-4-10-4.3l-15.2-1.1 1.8-16z",
    fill: "url(#d)",
    transform: "translate(37)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#639EF7",
    strokeWidth: 6,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.5 304.6c0-7.6 6.2-13.8 13.8-13.8 4.9 0 9.2 2.5 11.7 6.4M374.5 305.8c0 7.6 6.2 13.8 13.8 13.8 4.9 0 9.2-2.5 11.7-6.4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128.2 300.7l-20.1-.3-10-.1h-1.5l-1.2.3c-.4.2-.8.4-1.1.7-.3.3-.6.6-.9 1-.2.4-.5.8-.6 1.2-.1.2-.1.4-.2.7v1.1c-.2 2.4-1.1 4.7-2.5 6.6-1.4 1.9-3.4 3.4-5.6 4.2-1.1.4-2.2.7-3.4.8h-1.6l-1.3-.1-20-1.6v-3.4l20-1.6 1.3-.1h.9c.5-.1 1-.3 1.4-.5.9-.5 1.7-1.1 2.2-2 .5-.8.8-1.8.7-2.7v-1.4c0-.6.1-1.2.2-1.8.2-1.2.7-2.4 1.2-3.5.6-1.1 1.3-2.1 2.1-3 .9-.9 1.8-1.7 2.9-2.3 1.1-.6 2.2-1.1 3.5-1.4.6-.1 1.2-.3 1.9-.3l.9-.1h.7l10-.1 20.1-.3v10z",
    fill: "url(#e)",
    transform: "translate(37)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#639EF7",
    strokeWidth: 6,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.9 314.1c0 6.7-5.4 12.1-12.1 12.1-4.3 0-8-2.2-10.2-5.6M95.9 313c0-6.7-5.4-12.1-12.1-12.1-4.3 0-8 2.2-10.2 5.6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M222.7 197h0c0 7.2-5.8 13-13 13h-15.2",
    stroke: "#315186",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 14)"
  }, /*#__PURE__*/React.createElement("image", {
    x: 232.802,
    y: 82.35,
    width: 39.6,
    height: 91.5,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#639EF7",
    cx: 270.9,
    cy: 59.9,
    r: 27.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 270.9,
    cy: 59.9,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#325187",
    cx: 182.1,
    cy: 262.5,
    r: 6.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#325187",
    cx: 246.2,
    cy: 304.6,
    r: 15.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#325187",
    cx: 241.9,
    cy: 175.5,
    r: 6.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#325187",
    cx: 257,
    cy: 189.5,
    r: 5.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#325187",
    cx: 266.5,
    cy: 57,
    r: 5.5
  }), /*#__PURE__*/React.createElement("image", {
    x: 185.272,
    y: 44.371,
    width: 29,
    height: 101.9,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAABnCAYAAAAXHfKrAAAABGdBTUEAALGPC/xhBQAACfhJREFUaAXtWl2IJUcVrjpVfX/2zs5kZ3Z0J9nN4hKDRvZBA1GfXEjERFD04QY0iYiCEvxBn/KYi08rghBXwRXJCoIP7pMoKD7IPEgU1ISImQgbTcjuZNy/mc3M3Lk/3VXld6p/bt+ZvrMzc/sSCFvcvl1dXX2+Oud89Xe65YPNs6dd5B6RQlbFqOScdNZGKqCXGjd7f15cbHVHVd1ruRZGnJZE3xFCTo9+SAoi24mk/cWGrv0N9cYHVloH1roZIQiHi7GlRDbJcwnh2qiKEq4eTW3gYvykjaUVpWQYi2KZKWCaj3Gc4hrpvbj2OP9a1YNVwBpBEGNxMA4faZ6xoLEEqDV8AcOUkDT1pRVKCW9d5QCQasj5WEfJN1lbVBU9UwKsEFocYnmAcylkrLB3MfB8MyTMgQLyDUi8Mia8FiKAtpRpmsqTks3qYf09S07oPOHSigc868ADw4MxRiyG84ybJFbYs9yi8K60dLxzrDFFkOKlJ9KA7DWOL9GLhYTGMLUTphxkDYXBYJ0YNcHFaWBoXBCAnYmssd1qGDDfx04wNXCVzlvWC+XuM/AxrCGpLQN7uROZUmgdmxr6Evpqyp0dAxe6m3PWoLd3g/pqzvsHVxzdKRAUpuwdCBpwDTjczx1zAM5mOpSQYOoKhmFIk35MhMjExA6u9OyGNSTPJahDpbjXN1sTKZeaOEGK9QGYT0xwRUI5XMs+iu6Oy8f815Eym+S03UHrvGAeYGAIJ1Kr5G8eLE+1xsKykDrEwarhwJnQvfx1XEZgPWklKBi9VtgvPD317IM9pckpNidI5M/ot+Sv4zJijWWlRH0xSSwtLmKoBmOHxsxt7SdmNbqvquAG+3n8BFsisWlxSvjsizifJmY1E9CVyGrfOTUEs3CVnOM8zAwT+zKFZqFxuCqJ0zwfc/LwqX7pmQvZDnyCzzFJuCgtiIvH+ffAEqz1dh4hKZ6djLMyCKuNubwXRjxx++JY42KVs6cVGoZF4ZYM3PLSzJWyJgm2JEwJq6YjWDxJxAs8j46uhSmkH1BnfT6aL2XcjE0NJMm9NHUpo2Fhx2We6SAd+8LYupt/4OOlmBoMOgONIZiXsMnh834UQxkaxQMIcZ3gkLi+tJg0z9viwH+xxhggtic2OyN49dgi6FIYWEtLHpiItjBFob+kxgZozuzeIhi5Ql6u9MrBpleuMxy9hnEzZJLtPNj3zAHfxnJQISXW2MmOI9a42H3se8IKxPh9TTnYHtgpqORgR96i+JR5F1fIs915IDPlac3ikGBOzy/+Q5F3MN/ig5kNVsM4QcBOLifFpmaFcUA+EmuIU663Mqjj6bBEWudslwCmCjF4mrhB8LHtVfKl6d0DnWNgv3wFuUeIZVPDHNZUtqL5v5/J2eJAmP4hb1ysprwfGcDPRHydO/z2VFFnWujVixfLoXassZ8hktYXac0WCW2vHXLQJbebO7jCyaiQgWWZIZE+IoBbtcP1tL8N3T/IRUYu7jCezXk65yV6ypeGm4xcmAEwcsUBlxg9D8nEwq/YGsMV937lyYWN/hZ6MZBZOA5P79wZZeXCpmO1tFckBZj0bC1rc4rk8eMBRohGdnvcDAnfP2gdUZ9dHeg5MC5a7nkSTbYsZibWkE3sDybatnzuoTKyGauBtM2T3JI48Z0RM2ZaZd/nHDArCYBCEWgEs3pXZxQ+OLIwAebpMDEtL7a2JzZ7ySr77rQdZ+c1GpOLG+y8v/8SD4zFnjfzqMc54oMg/VpEHBgpJ3lTY+jIRog4UjsQzjOWs66PoPH/JAecSkr0oaWmw9p9HSuQeELOulHsc17zIgaGJYg8XK/wzXIStZ7lLZNegaY7I1hpI4gCqelYP+TtRDmJnQtN3TI23tj9JsxOzykGzI1tzAmt7IebLcfxiLGTJ1el3b8iRLTpzb1NpO/b2EVIpY6jhU80jq2fbLXiMN+2qvu69MCNey7dcpH9BxiWbVAYMCMa920nDiEY90mp9XffXHj7kc+cd4jtHzx5sjSbTjU+td5U+tCPbdSdKxy+uCFC4U1R9LaU6mWsOV9Ge5altNcwrF1FTHe5EV5+6yff+MCqd99t2pSx9GvnO/caLX8lnPmodQhgFyX2PeDh754KsOQMex3u3wBfA+uvIjZ2HXP7Szbc+ssbK0deXWwVEDaRmwE/9q1L1btPv/cJEVR/YKNwlm07SFk1X8T7ZSYiD2Y4gQAUoTlGkgqN6a9g47dkpf1d0Fv77c++vnATlfPCvIwhiU+eby/UAnGWVKUZht16jD1UZeD3rFXJ2OOr4Q+ROKmCroui111kfl+x3ed++vTcW9vBh6Q2f+1UfXX1oUp1+hlMRo+GUb+aBUYSoIxwGfDOjN8AEIUYaW9hqv8NprXn1qenXr34OMa+JHlWpxd8Y+be2RfDXu8c/PxHhB96PpiaVEh0S6uPPGNsx87SBLDYPMaHx60Ivlm/efNYfoobAmZJ5z4te7OzjRe63f4Pod0FJ801FdTQxTF1DtlnJK6/wUOt54mz06DE5xVNffYr378xlT41UtSXL7xeC3vTpyqq8gksBB91Lno4qNYarAxr5LXi7u37+O6TFkzvSLp/RsJ88cKbU/8WLX63t0s603L6/oW1Rt/UPigq7iMVpd5vnXyfdeYesnIBb98CMPiowhttY0L0RG7AMIFTTpAO+qbfe2ZjpvHzi03R3hU4bdNjP7pUvW/2vupWt3vEqNp7iNaPyrByxAr4kWhGK33KhOZz6McnrDFwXwyegrIczmN6/asJe19oz911eU/AaQNEq0VN0dSNkw9Qe+u6ngd3og2h6GT3SLftPoae8DQI+BCAB+vz7GHfnA4un6rW+n/aH3BOSD7Lk8Z/Tok6hVsPa+vOSh3cj28KwMZhs/tnnPsegu3P72B1XuBe8y2Q5Zdfku3pdnfRSrkIwm2M7gH6uJP1WinAaQPPfXtuHSGLF/AJxQ24tJjqZE8oonqpwNwAI+0rQFzj0EVRx5fWHiYb6tKBdX8T0yYiB8X6xhsDvMItHVjOTGfjceqConPpwKbf3VNPKR24SLuisjvARVaZSNm7x9Suv8Ef7oDZ/BtxIPpcusZK169hTbmJ0Fnxy3C8/cZnDrxOLTc9/9Wjm9iOYVUwUu5reAvRLh0Y9kXQgl9wFCcsIlejwPUnAFwMOCiFC7BDeweA4ybcAR64YsK5O6aesIEH4t9dpsbW8rbLn8lobKMVDJldbCUHtk1yaJIU+FZpIsCW6IYzIb6YYrRh5a21l/GVcac4urOjnfsssNZAMUzLmKP4P5eIKldtEPQmAswb8SIzM75z/SgIu+OHBnPK7Cs7ER/vpQXvGPBEfIz98R+w+V6x7hDiZAj65ZLpdl/c6HW2JgIsRPtfZOv/tYivR1HytWkCPj/fuTWzdLz3f0dpLLP+ZXtVAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#639EF7",
    cx: 190.8,
    cy: 34.5,
    r: 34.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 190.8,
    cy: 34.5,
    r: 22.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#325187",
    cx: 187.7,
    cy: 31.6,
    r: 6.9
  }), /*#__PURE__*/React.createElement("image", {
    x: 126.577,
    y: 103.066,
    width: 74.6,
    height: 65.6,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.6 239.6l-20-.5-5-.1-2.5-.1-1.6-.1-1.6-.2c-4.3-.5-8.4-1.9-12.1-4.1-7.4-4.3-12.8-11.7-14.6-19.9-.5-2.1-.7-4.1-.8-6.2V206c0-.6-.1-1.3-.1-1.9-.3-2.5-1.1-4.9-2.4-7.1-2.6-4.4-7.1-7.8-12.2-8.9-.6-.1-1.3-.3-1.9-.3-.3 0-.7-.1-1-.1l-1.1-.1-5-.2-10-.4-2.6-.1c-1 0-2-.1-2.9-.3-1.9-.3-3.8-.8-5.7-1.5-3.7-1.3-7-3.4-9.8-6.1-.4-.3-.7-.7-1-1l-.9-.9-1.7-1.9-3.4-3.7-6.7-7.4 3.8-3.8 7.4 6.7 3.7 3.4 1.9 1.7.9.8c.3.2.5.5.8.7 2.2 1.8 4.8 3.1 7.5 3.8 1.3.4 2.7.6 4.1.7.7 0 1.4.1 2.1 0l2.5-.1 10-.4 5-.2h1.4c.5 0 1 0 1.5.1l3 .3c4 .7 7.9 2.2 11.3 4.4 3.4 2.2 6.4 5.1 8.7 8.6 2.3 3.4 3.9 7.3 4.7 11.5.2 1 .3 2.1.4 3.1l.1 2.6c.1 1.2.3 2.5.7 3.7 1.3 4.8 4.8 8.8 9.1 11 2.1 1.1 4.5 1.7 6.8 1.9h1.8l2.5-.1 5-.1 20-.5v15.7h-.1z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#639EF7",
    cx: 126.2,
    cy: 85.8,
    r: 27.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 126.2,
    cy: 85.8,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#325187",
    cx: 120.7,
    cy: 80.3,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.6 203.7l7.6.4h1.4c.4 0 .8 0 1.2-.1.8-.1 1.6-.4 2.4-.8.8-.4 1.5-.9 2.1-1.5.6-.6 1.2-1.3 1.6-2.1.4-.8.8-1.6 1-2.5.1-.4.1-.9.2-1.4.1-.8.1-1.6.3-2.4.3-1.6.8-3.1 1.6-4.5.7-1.4 1.7-2.7 2.7-3.8 1.1-1.1 2.3-2 3.7-2.8 1.3-.7 2.8-1.3 4.3-1.6.7-.2 1.5-.2 2.2-.3h2.2l3.8.2 7.6.4v3.4l-7.6.4-3.8.2h-.9c-.3 0-.5.1-.8.1-.5.1-1 .2-1.5.4-1 .3-1.9.8-2.7 1.4-.8.6-1.5 1.3-2.1 2-.6.8-1.1 1.6-1.4 2.5-.3.9-.6 1.8-.6 2.8-.1.5 0 .9 0 1.4 0 .8 0 1.6-.1 2.4-.1 1.6-.6 3.2-1.2 4.7s-1.5 2.9-2.5 4.2c-1 1.3-2.3 2.4-3.7 3.3-.7.5-1.4.9-2.2 1.2-.8.3-1.5.7-2.4.9-.8.3-1.6.4-2.5.6-.4.1-.8.1-1.3.1l-.6.1h-.5l-7.6.4v-9.7h.1z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#639EF7",
    strokeWidth: 6,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.4 182.3c0-6.7 5.4-12.1 12.1-12.1 4.3 0 8 2.2 10.2 5.6M320.4 183.4c0 6.7 5.4 12.1 12.1 12.1 4.3 0 8-2.2 10.2-5.6"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#639EF7",
    strokeWidth: 8,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9 165c-7.3 7.3-19.1 7.3-26.4 0-4.7-4.7-6.4-11.2-5-17.3M33.1 163.8c7.3-7.3 7.3-19.1 0-26.4-4.7-4.7-11.2-6.4-17.3-5"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlien);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Alien.1abc63564d0d0169df74698c36c7410f.svg";